<template>
  <div class="home">
      <ul class="breadcrumbs" >
          <li><div><a href="https://www.brighton.com">HOME</a></div></li>
          <li><div><a href="https://app.brighton.com/text-messaging">Text messaging - opt out</a></div></li>
      </ul>
    <!-- <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
      <h1>BRIGHTON TEXT MESSAGING - OPT OUT </h1>
      <div class="info" v-if="!submitted">
        <span class="text">Please complete the following information to stop receiving Brighton text messages.</span>
        <span class="error" v-if="error != ''">{{error}}</span>
        <div class="sec"><label for="">First Name: </label><input type='text' :class="{invalid: !firstName.valid}" v-model="firstName.value" placeholder="First Name"/></div>
        <div class="sec"><label for="">Last Name: </label><input type='text' :class="{invalid: !lastName.valid}" v-model="lastName.value" placeholder="Last Name"/></div>
        <div class="sec"><label for="">Phone Number: </label><VuePhoneNumberInput  @input="updatePhone" class="phone" :class="{invalid: !phone.valid}" v-model="phone.value" type="text" placeholder="Phone Number (123) 456-7890" /></div>
        <!-- <div class="sec"><label for="">Confirm Phone Number: </label><VuePhoneNumberInput  @input="updatePhone" class="verifyPhone":class="{invalid: !verifyPhone.valid}" v-model="verifyPhone.value" type="text" placeholder="Verify Phone Number" /></div> -->
        <div class="sec"><button @click="save()">Save</button></div>
      </div>
      <div class="confirmation info" v-else>
        <span class="t1 text">{{this.firstName.value}} {{this.lastName.value}},<br/>
        Your phone number {{this.phone.value}} has been removed from Brighton Text Messaging.<br/>
        Have a Brighton Day.
        
        </span>
      </div>
  </div>
</template>

<script>
const axios = require('axios');
import VuePhoneNumberInput from 'vue-phone-number-input';
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'home',
  components: {
    // HelloWorld
    VuePhoneNumberInput
  },
  data () {
    return {
      firstName: {
        value: '',
        valid: true
      },
      lastName: {
        value: '',
        valid: true
      },
      phone: {
        value: '',
        valid: true
      },
      verifyPhone: {
        value: '',
        valid: true
      },
      submitted: false,
      error: ''
      
    }
  },
  methods: {
    async save() {
      this.error = ''
      this.lastName.valid = true
      this.firstName.valid = true
      this.phone.valid = true 
      this.verifyPhone.valid = true
      if(this.firstName.value.trim() == '') 
        this.firstName.valid = false
      if(this.lastName.value.trim() == '') 
        this.lastName.valid = false
      if(this.phone.value.trim() == '')
        this.phone.valid = false
      this.$forceUpdate()
      if(this.error != '' || !this.firstName.valid || !this.lastName.valid || !this.phone.valid || !this.verifyPhone.valid)
        return false 
      
      // var formData = new FormData();  
      // formData.append('firstName', this.firstName.value)
      // formData.append('lastName', this.lastName.value)
      // formData.append('phone', this.phone.value)
      let returnedData = await axios( 
      {
          method: 'POST',
          // url: `https://app.brighton.com/text-opt-out/api/submit`,
          url: `https://api2.brightoncollectibles.com/textoptin/optout`,
          // url: `http://localhost:3000/textoptin/optout`,
          responseType: 'json',
          data: {
            firstName: this.firstName.value,
            lastName: this.lastName.value,
            phone: this.phone.value
          },
          config: { headers: {'Content-Type': 'application/json' }},
      })
      if(returnedData.data.success) {
        this.submitted = true
      } else {
        this.error = returnedData.data.error
      }
    },
    updatePhone(e){
        // console.log('update phone', this.phone.value, this.phone.value.length)
        // console.log(e)
    },
  },
  mounted() {
    var elements = document.getElementsByClassName('field-input')
    Array.prototype.filter.call(elements, (e, index)=>{
      e.addEventListener('keydown', (e)=>{
        if(e.code == 'Backspace' && this.phone.value[this.phone.value.length -1] == ')'){
            this.phone.value = this.phone.value.substring(0, this.phone.value.length-1)
        }
        if(e.code == 'Backspace' && this.verifyPhone.value[this.verifyPhone.value.length -1] == ')'){
            this.verifyPhone.value = this.verifyPhone.value.substring(0, this.verifyPhone.value.length-1)
        }
      })
    })
  }
}
</script>
<style lang="scss">

  .home{
    text-align: left;
    ul.breadcrumbs{
        display: block;         
        list-style-type: none;
        margin-top: 10px;
        text-align: left;
        padding-left:0;
	  }
    ul.breadcrumbs li {
      display: inline-block;
      line-height:1;
        /* background: url(https://www.brighton.com/store_image/site/arrow.gif) 0 center no-repeat; */
        /* background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zd…c4LDE5Ljc4LDAsMCwxLDM4LTcuNywxOS43OCwxOS43OCwwLDAsMSwzOCw3LjdaJy8+PC9zdmc+); */
      text-align:left;
      width:auto;
      div{
        background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCA3NiA2Ny40Jz48ZGVmcz48c3R5bGU+LmF7ZmlsbDojOTE5MTkxO308L3N0eWxlPjwvZGVmcz48dGl0bGU+aGVhcnQ8L3RpdGxlPjxwYXRoIGNsYXNzPSdhJyBkPSdNNzYsMTkuOGEyOC40NSwyOC40NSwwLDAsMS0yLDkuN0M2OC4zLDQzLjcsMzcuOCw2Ny40LDM3LjgsNjcuNFM4LDQ0LjUsMi4xLDI5LjRBMzAuNDksMzAuNDksMCwwLDEsMCwxOS44YTE5Ljc4LDE5Ljc4LDAsMCwxLDM4LTcuNywxOS43OCwxOS43OCwwLDAsMSwzOCw3LjdaJy8+PC9zdmc+);
        background-repeat:no-repeat;
        background-position:left center;
        background-size:10px 10px;
      }
    }
	ul.breadcrumbs li a {
    text-transform: uppercase;
    display: block;
    text-decoration: none;
    margin-left: 5px;
    margin-right: 15px;
    color:black;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: .08em;
    text-transform: uppercase;
      /* background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zd…c4LDE5Ljc4LDAsMCwxLDM4LTcuNywxOS43OCwxOS43OCwwLDAsMSwzOCw3LjdaJy8+PC9zdmc+); */
	  /* background: url(https://www.brighton.com/store_image/site/arrow.gif) no-repeat; */
      /* background: url(https://www.brighton.com/store_image/site/arrow.gif) 0 center no-repeat; */
	  padding-left: 9px;
	  background-position: 0 50%;
	
	}
    ul.breadcrumbs li a:hover{
        text-decoration: underline;
    }



    h1{
      text-align:center;
      font-size:20px;
      font-weight:normal;
    }
    .info{
      box-shadow: 0 1px 4px rgba(0,0,0,.4);
      padding:20px;
      max-width:600px;
      box-sizing: border-box;
      margin:0 auto;
 
      .t1{
        line-height:2;
      }
      .error{
        display:block;
        color:red;
        font-size:12px;
        /* border:1px solid red; */
        padding:10px 0;

      }
      .sec{
        /* min-height:35px; */
        /* padding:10px; */
        box-sizing:border-box;
        display:block;
        margin:5px 0;
        margin-bottom:10px;
        label{
          min-width:180px;
          display:block;
          text-align:left;
          font-size: 13px;
          color: #999;  
          line-height:1.4;
        }
        button{
          cursor: pointer;;
          border:1px solid #000;
          padding:10px 20px;
          background:black;
          color:white;
          font-size:18px;
          text-transform: uppercase;
          /* letter-spacing: 6px; */
          /* font-weight: bold; */
          transition:all 0.2s;
        }
        button:hover{
          /* background:black;
          color:white; */
        }
        input[type=text],
        input[type=tel] {
          padding:9px;
          width:100%;
          box-sizing: border-box;
          border:1px solid #999;
          /* border-color:rgb(238, 238, 238); */
          /* border-width:1px; */
          /* height:18px; */
        }
        input.invalid,
        .invalid input{
          border:1px solid red;          
        }
        .vue-phone-number-input{
          display:block;
        }
        .country-selector,
        .field-label{
            display:none;
        }

      }
    }
  }
</style>